/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

export type SoldGoodsUncategorisedListItemType = typeof SoldGoodsUncategorisedListItemType[keyof typeof SoldGoodsUncategorisedListItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SoldGoodsUncategorisedListItemType = {
  other: 'other',
  uncertain: 'uncertain',
} as const;
